import ProdutoDestaque1 from './ProdutoDestaque1';

export default ProdutoDestaque1;